import { useState } from 'react';
import { useTheme } from '../context/ThemeContext.jsx';

export default function StarRating({ rating, avgRating, ratingCount, onRate, size = 16, interactive = false }) {
  const { theme } = useTheme();
  const [hoverIndex, setHoverIndex] = useState(0);

  const displayRating = interactive ? (hoverIndex || rating || 0) : (avgRating || 0);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
      <div
        style={{ display: 'flex', gap: 2, cursor: interactive ? 'pointer' : 'default' }}
        onMouseLeave={() => interactive && setHoverIndex(0)}
      >
        {[1, 2, 3, 4, 5].map(i => {
          const filled = i <= Math.round(displayRating);
          return (
            <span
              key={i}
              onClick={e => {
                e.stopPropagation();
                if (interactive && onRate) onRate(i);
              }}
              onMouseEnter={() => interactive && setHoverIndex(i)}
              style={{
                fontSize: size,
                color: filled ? '#F2994A' : theme.textDisabled,
                transition: 'color 0.1s, transform 0.1s',
                transform: interactive && hoverIndex === i ? 'scale(1.2)' : 'scale(1)',
                lineHeight: 1,
                userSelect: 'none',
              }}
            >{filled ? '\u2605' : '\u2606'}</span>
          );
        })}
      </div>
      {avgRating != null && (
        <span style={{ fontSize: size * 0.65, color: theme.textMuted, fontWeight: 500 }}>
          {avgRating.toFixed(1)}
        </span>
      )}
      {ratingCount > 0 && (
        <span style={{ fontSize: size * 0.55, color: theme.textGhost }}>
          ({ratingCount})
        </span>
      )}
    </div>
  );
}
